import React from "react";
import { useUserAuth } from "../../../contexts/UserAuthContext";
import { useToast } from "../../../contexts/ToastContext";
import { useFavoritesQuery, useDeleteFavoritesMutation } from "../../../hooks/profile/queries";
import FavoritesView from "../../../components/profile/views/FavoritesView";

/**
 * FavoritesPage - User's favorite products
 */
const FavoritesPage = () => {
  const { user } = useUserAuth();
  const { showToast } = useToast();
  const userId = user?.id || user?._id;

  const { data: favorites = [], isLoading, isError, refetch } = useFavoritesQuery(userId);
  const deleteMutation = useDeleteFavoritesMutation();

  const handleDelete = async (productIds) => {
    const ids = Array.isArray(productIds) ? productIds : [productIds];
    try {
      const result = await deleteMutation.mutateAsync(ids);
      const removed = Number.isFinite(result?.removedCount)
        ? result.removedCount
        : ids.length;
      showToast({
        message:
          removed === 1
            ? "Removed from favorites"
            : `Removed ${removed} favorites`,
        type: "success",
      });
    } catch (err) {
      showToast({
        message: err.response?.data?.error || "Failed to remove favorites",
        type: "error",
      });
      throw err;
    }
  };

  return (
    <FavoritesView
      favorites={favorites}
      loading={isLoading}
      isError={isError}
      onRetry={refetch}
      onDelete={handleDelete}
    />
  );
};

export default FavoritesPage;
